import { isUserLoggedIn } from "../Helpers/RoutesHelper";
import { useEffect, useState } from "react";
export function useIsLoggedIn() {
    var _a = useState(false), isLoggedIn = _a[0], setIsLoggedIn = _a[1];
    var _b = useState(true), loggedInLoading = _b[0], setLoggedInLoading = _b[1]; // [AM]: Let's keep in just in case we need async actions
    useEffect(function () {
        var res = isUserLoggedIn();
        setIsLoggedIn(res);
        setLoggedInLoading(false);
    }, []);
    return { isLoggedIn: isLoggedIn, loggedInLoading: loggedInLoading };
}
